import { render, staticRenderFns } from "./createFood.vue?vue&type=template&id=09be076c&scoped=true&"
import script from "./createFood.vue?vue&type=script&lang=js&"
export * from "./createFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be076c",
  null
  
)

export default component.exports